export function fetchJson(url) {
    return fetch(url,
        {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
        .then(async response => {
            const isJson = response.headers.get('content-type')?.includes('application/json')
            const data = isJson ? await response.json() : [];

            if (!response.ok) {
                console.log('response not ok');
                const error = (data && data.message) || response.status;
                return Promise.reject(error);
            }
            return Promise.resolve(data);
        })
        .catch(error => {
            console.error(`Error loading json! ${url}`, error);
            return Promise.reject(error);
        });
}

export function fetchIdentity(auth, url) {
    const token = 'Bearer ' + auth.access_token;
    const avantiCtx = auth.profile.AvantiCtx;

    return fetch(url,
        {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token,
                'AVANTI_CTX': avantiCtx
            }
        })
        .then(async response => {
            const isJson = response.headers.get('content-type')?.includes('application/json')
            const data = isJson ? await response.json() : [];

            if (!response.ok) {
                console.log('response not ok');
                const error = (data && data.message) || response.status;
                return Promise.reject(error);
            }
            return Promise.resolve(data);
        })
        .catch(error => {
            console.error(`Error loading from API! ${url}`, error);
            return Promise.reject(error);
        });
}

export function fetchApi(auth, url) {
    const token = 'Bearer ' + auth.access_token;
    //console.log("Bearer", token);
    const avantiCtx = auth.profile.AvantiCtx;
    //console.log("avantiCtx", avantiCtx);
    const CONFIG = window.CONFIG();

    return fetch(`${CONFIG.IDENTITY_API_ENDPOINT}/${url}`,
        {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token,
                'AVANTI_CTX': avantiCtx
            }
        })
        .then(async response => {
            const isJson = response.headers.get('content-type')?.includes('application/json')
            const data = isJson ? await response.json() : [];

            if (!response.ok) {
                console.log('response not ok');
                const error = (data && data.message) || response.status;
                return Promise.reject(error);
            }
            return Promise.resolve(data);
        })
        .catch(error => {
            console.error(`Error loading from API! ${url}`, error);
            return Promise.reject(error);
        });
}

export function postApi(auth, url, change) {
    console.log(change);
    const token = 'Bearer ' + auth.access_token;
    const body = JSON.stringify(change.data);
    console.log("body", body);
    const CONFIG = window.CONFIG();
    return fetch(`${CONFIG.IDENTITY_API_ENDPOINT}/${url}?id=${change.key}`,
        {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: body
        })
        .then(async response => {
            const isJson = response.headers.get('content-type')?.includes('application/json')
            const data = isJson ? await response.json() : [];

            if (!response.ok) {
                console.log('response not ok');
                const error = (data && data.message) || response.status;
                return Promise.reject(error);
            }
            return Promise.resolve(data);
        })
        .catch(error => {
            console.error(`Error loading from API! ${url}`, error);
            return Promise.reject(error);
        });
}

export function callApi(auth, url) {
    console.log('auth', auth);
    const token = 'Bearer ' + auth.access_token;
    const CONFIG = window.CONFIG();
    const avantiCtx = auth.profile.AvantiCtx;
    console.log('avantiCtx', avantiCtx);
    return fetch(`${CONFIG.IDENTITY_API_ENDPOINT}/${url}`,
        {
            method: 'POST',
            headers: {
                'Accept': '*/*',
                'Content-Type': 'text/html; charset=utf-8',
                'Authorization': token,
                'AVANTI_CTX': avantiCtx
            }
        })
        .then(async response => {
            if (!response.ok) {
                console.log('response not ok');
                const error = response.status;
                return Promise.reject(error);
            }
            return;
        })
        .catch(error => {
            console.error(`Error loading from API! ${url}`, error);
            return Promise.reject(error);
        });
}
